
// Alert
export const ERR_POSTING = "An Error occurred while Submitting data."
export const ERR_GETTING = "An Error occurred while Fetching data."
export const SUCC_FEEDBACK = "Feedback added successfully!"
export const ENTER_FEEDBACK="Please Add Feedback."
export const ERR_ALERT_TITLE = "Error"
export const SUCC_ALERT_TITLE = "Success!"
export const SUCC_APPROVE_TITLE = "Approved!"
export const SUCC_APPROVE_TEXT = "The product has been approved successfully!"
export const SUCC_REJECTPRODUCT_TXT = "The product has been rejected successfully!"
export const SUCC_REJECTPRODUCT_TITLE = "Product Rejected!"
export const ERROR = "ERROR"
export const ERR = "error"
export const CONFIRM = "OK"
export const CONFIRM_TITLE = "Are you sure?"
export const CONFIRM_TXT_REJ_ALL = "You are about to reject the selected product(s)."
export const CONFIRM_TXT_ACC_ALL = "You are about to approve the selected product(s)."
export const CONFIRM__ACC_ALL_YES_BUTTON = "Yes, approve them!"
export const CONFIRM__REJ_ALL_YES_BUTTON = "Yes, reject them!"
export const CONFIRM__DEL_COIN_YES_BUTTON = "Yes, delete it!"
export const CONFIRM_TXT_DEL_COIN = "You won't be able to revert this!"
export const SUCC_COIN_DEL = "'Deleted!', 'Your coin has been deleted.', 'success'"
export const CONFIRM_PASSWORD_ERR = "New password and Confirm password do not match!"
export const SUCC_ADD_CUS = "Customer Added Successfully !"
export const SUCC_EDIT_PROFILE = "Your profile has been updated successfully!"
export const CONFIRM_BLOCK_CUS = "You want to block this customer?"
export const CONFIRM_UNBLOCK_CUS = "You want to unblock this customer?"
export const SUCC_MFA_TITLE = "MFA Configuration updated"
export const SUCC_MFA_TXT = "MFA Configuration updated successfully!"
export const SUCC_EDIT_BTYPE = "Business Type updated successfully."
export const SUCC_ADD_BTYPE = "Business Type added successfully."
export const NETWORK_NOT_OK = "Network response was not ok"

export const CONFIRM_TXT_DEL = "You won't be able to revert this!"
export const SUCC_SUB_TEXT = 'Subscription added successfully!'
export const SUCC_SUB_EDT_TEXT = 'Subscription updated successfully!'
export const SUCC_MAIL_SEND = "Email sent successfully!"

export const SUCCESS_SAVE_PERMISSIONS = 'Permissions Saved Successfully!'
export const VOUCHER_SUCCESS = 'Voucher Assigned Successfully'
export const VOUCHER_ERROR = 'An error occurred while submitting data.'
export const VALUES = 'Updated state values:'
export const CURRENT_VALUES = 'Current state values:'
export const ORG= 'Fetched organizations:'
export const UPT_ORG= 'Updated state values with organizations:'
export const ERR_ORG= 'Error loading organizations:'
export const REND_ORG= 'Rendering organizations in dropdown:'


